export const ORIGIN_SOURCE_DATASETS = [
  { label: 'External', pattern: 'horizontal', key: 'external' },
  { label: 'Manual', pattern: 'diagonal-right', key: 'manual' },
  { label: 'Autobook', pattern: 'diagonal-left', key: 'autobook' },
];

export const TERMINAL_DATASETS = [
  { label: 'Trapac', pattern: 'diagonal-right', key: 'trapac' },
  { label: 'Matson', pattern: 'horizontal', key: 'matson' },
  { label: 'SSA Marine', pattern: 'diagonal-left', key: 'ssaMarine' },
  { label: 'Everport', pattern: 'vertical', key: 'everport' },
  { label: 'Yusen', pattern: 'cross', key: 'yusen' },
];

export const STATUS_DATASETS = [
  { label: 'Rejected', pattern: 'diagonal-left', key: 'rejected' },
  { label: 'Used', pattern: 'diagonal-left', key: 'used' },
  { label: 'Canceled', pattern: 'vertical', key: 'cancelled' },
  { label: 'Expired', pattern: 'horizontal', key: 'expired' },
  { label: 'Rescheduled', pattern: 'cross', key: 'rescheduled' },
  { label: 'Scheduled', pattern: 'diagonal-right', key: 'scheduled' },
];

// Legend items configuration (same as datasets but for legend display)
export const ORIGIN_SOURCE_LEGEND_ITEMS = ORIGIN_SOURCE_DATASETS.map(
  ({ label, pattern }) => ({
    label,
    pattern,
  })
);

export const TERMINAL_LEGEND_ITEMS = TERMINAL_DATASETS.map(
  ({ label, pattern }) => ({
    label,
    pattern,
  })
);

export const STATUS_LEGEND_ITEMS = STATUS_DATASETS.map(
  ({ label, pattern }) => ({
    label,
    pattern,
  })
);
